/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Edge_BranchInputs */

const cs_workflow_edge_branch = /** @type {(inputs: Workflow_Edge_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Větev`)
};

const en_workflow_edge_branch = /** @type {(inputs: Workflow_Edge_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch`)
};

/**
* | output |
* | --- |
* | "Branch" |
*
* @param {Workflow_Edge_BranchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_edge_branch = /** @type {((inputs?: Workflow_Edge_BranchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Edge_BranchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_edge_branch(inputs)
	return cs_workflow_edge_branch(inputs)
});